<template>
  <div>
    <hr />

    <!-- Barra de acciones -->
    <div class="row g-2 align-items-center mb-3">
      <div class="col-auto ms-auto d-flex align-items-center gap-2" v-if="archivoplas.length > 0">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width:75px"
          @change="aplicarPaginacion(1)"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
    </div>

    <!-- Filtro global (aplica a ambas tablas) -->
    <div class="row g-2 mb-3" v-if="archivoplas.length > 0">
      <div class="col-md-4">
        <input
          v-model="filtroNombre"
          @input="aplicarPaginacion(1)"
          class="form-control form-control-sm"
          placeholder="Filtrar por nombre..."
        />
      </div>
    </div>

    <!-- Dos tablas: izquierda (sin -R) / derecha (con -R) -->
    <div class="row" v-if="archivoplas.length > 0">
      <!-- ───────────── Tabla izquierda: SIN "-R" ───────────── -->
      <div class="col-md-6">
        <div class="d-flex align-items-center" style="min-height: 31px;">
          <h6 class="fw-bold text-primary mb-0">
            Expediente Inicial <span class="badge bg-secondary">{{ archivoplasSinR.length }}</span>
          </h6>
        </div>
        <div class="table-responsive mt-2">
          <table class="table table-hover table-bordered table-sm">
            <thead class="table-dark">
              <tr>
                <th style="width:50px"></th>
                <th class="th-sort" @click="ordenarPor('nombre')">
                  Nombre <span>{{ iconOrden('nombre') }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="archivopla in datosPaginadosSinR"
                :key="archivopla.idArchivoPla"
                title="Doble clic para ver detalles"
                @dblclick="abrirModalEditar(archivopla.idArchivoPla)"
              >
                <td>
                  <span
                    class="material-icons"
                    style="font-size: 24px; color: blue; cursor: pointer"
                    @click="abrirModalEditar(archivopla.idArchivoPla)"
                    title="Datos del archivo"
                  >info</span>
                </td>
                <td>
                  <a :href="transformarRutaEnURL(archivopla.ruta)" target="_blank">
                    {{ archivopla.nombre }}
                  </a>
                </td>
              </tr>
              <tr v-if="archivoplasSinR.length === 0">
                <td colspan="2" class="text-center text-muted small py-3">Sin registros</td>
              </tr>
            </tbody>
            <tfoot v-if="archivoplasSinR.length > 0">
              <tr class="table-secondary">
                <td colspan="2" class="text-end fw-bold small">
                  Mostrando {{ datosPaginadosSinR.length }} de {{ archivoplasSinR.length }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Paginación tabla izquierda -->
        <nav aria-label="Paginación sin -R" v-if="totalPaginasSinR > 1">
          <ul class="pagination pagination-sm justify-content-center mb-0">
            <li class="page-item" :class="{ disabled: paginaActualSinR === 1 }">
              <a class="page-link" href="#" @click.prevent="irPaginaSinR(1)">«</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualSinR === 1 }">
              <a class="page-link" href="#" @click.prevent="irPaginaSinR(paginaActualSinR - 1)">‹</a>
            </li>
            <li class="page-item disabled">
              <span class="page-link">{{ paginaActualSinR }} / {{ totalPaginasSinR }}</span>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualSinR === totalPaginasSinR }">
              <a class="page-link" href="#" @click.prevent="irPaginaSinR(paginaActualSinR + 1)">›</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualSinR === totalPaginasSinR }">
              <a class="page-link" href="#" @click.prevent="irPaginaSinR(totalPaginasSinR)">»</a>
            </li>
          </ul>
        </nav>
      </div>

      <!-- ───────────── Tabla derecha: CON "-R" ───────────── -->
      <div class="col-md-6">
        <div class="d-flex align-items-center justify-content-between">
          <h6 class="fw-bold text-danger">
            Levantamiento de objeciones <span class="badge bg-secondary">{{ archivoplasConR.length }}</span>
          </h6>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            @click="cargarArchivos"
            title="Refrescar lista"
          >
            <span class="material-icons align-middle" style="font-size:16px">refresh</span>
          </button>
        </div>
        <div class="table-responsive mt-2">
          <table class="table table-hover table-bordered table-sm">
            <thead class="table-dark">
              <tr>
                <th style="width:50px"></th>
                <th class="th-sort" @click="ordenarPor('nombre')">
                  Nombre <span>{{ iconOrden('nombre') }}</span>
                </th>
                <th style="width:50px"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="archivopla in datosPaginadosConR"
                :key="archivopla.idArchivoPla"
                title="Doble clic para ver detalles"
                @dblclick="abrirModalEditar(archivopla.idArchivoPla)"
              >
                <td>
                  <span
                    class="material-icons"
                    style="font-size: 24px; color: blue; cursor: pointer"
                    @click="abrirModalEditar(archivopla.idArchivoPla)"
                    title="Datos del archivo"
                  >info</span>
                </td>
                <td>
                  <a :href="transformarRutaEnURL(archivopla.ruta)" target="_blank">
                    {{ archivopla.nombre }}
                  </a>
                </td>
                <td class="text-center">
                  <span
                    class="material-icons text-danger"
                    style="font-size: 22px; cursor: pointer"
                    @click.stop="confirmarEliminar(archivopla)"
                    title="Eliminar archivo"
                  >delete</span>
                </td>
              </tr>
              <tr v-if="archivoplasConR.length === 0">
                <td colspan="3" class="text-center text-muted small py-3">Sin registros</td>
              </tr>
            </tbody>
            <tfoot v-if="archivoplasConR.length > 0">
              <tr class="table-secondary">
                <td colspan="3" class="text-end fw-bold small">
                  Mostrando {{ datosPaginadosConR.length }} de {{ archivoplasConR.length }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <!-- Paginación tabla derecha -->
        <nav aria-label="Paginación con -R" v-if="totalPaginasConR > 1">
          <ul class="pagination pagination-sm justify-content-center mb-0">
            <li class="page-item" :class="{ disabled: paginaActualConR === 1 }">
              <a class="page-link" href="#" @click.prevent="irPaginaConR(1)">«</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualConR === 1 }">
              <a class="page-link" href="#" @click.prevent="irPaginaConR(paginaActualConR - 1)">‹</a>
            </li>
            <li class="page-item disabled">
              <span class="page-link">{{ paginaActualConR }} / {{ totalPaginasConR }}</span>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualConR === totalPaginasConR }">
              <a class="page-link" href="#" @click.prevent="irPaginaConR(paginaActualConR + 1)">›</a>
            </li>
            <li class="page-item" :class="{ disabled: paginaActualConR === totalPaginasConR }">
              <a class="page-link" href="#" @click.prevent="irPaginaConR(totalPaginasConR)">»</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Sin resultados (no hay ningún archivo en absoluto) -->
    <div v-if="sinResultados" class="alert alert-warning mt-3" role="alert">
      No se recuperaron archivos.
    </div>

    <!-- Modal -->
    <Teleport to="body">
      <div
        class="modal fade"
        id="ventanaModal"
        tabindex="-1"
        aria-labelledby="ventanaModalLabel"
        aria-hidden="true"
        ref="modalElement"
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <span class="material-icons" style="font-size:24px; color:white">description</span>
              <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                @click="cerrarModal"
                aria-label="Cerrar"
              ></button>
            </div>
            <div class="modal-body">
              <div class="info-registro p-3 rounded">
                <!-- ID -->
                <div class="row mb-2" v-if="btnEditar">
                  <div class="col-3">
                    <small class="text-muted fw-bold">ID Archivo</small>
                  </div>
                  <div class="col-9">{{ datoArchivoPla.idArchivoPla }}</div>
                </div>
                <!-- Campos dinámicos -->
                <div class="row mb-2" v-for="campo in campos" :key="campo.label">
                  <div class="col-3">
                    <small class="text-muted fw-bold">{{ campo.label }}</small>
                  </div>
                  <div class="col-9 text-break">{{ campo.value }}</div>
                </div>
              </div>
              <!-- Botón descarga -->
              <div class="text-end mt-3">
                <a
                  v-if="datoArchivoPla.ruta"
                  :href="transformarRutaEnURL(datoArchivoPla.ruta)"
                  target="_blank"
                  class="btn btn-outline-primary btn-sm"
                >
                  <span class="material-icons align-middle me-1" style="font-size:16px">download</span>
                  Abrir / Descargar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";

export default {
  name: "ArchivoPlaLista",
  props: {
    p_idTramite:  { type: Number, default: null },
    p_idPlanilla: { type: Number, default: null },
  },

  data() {
    return {
      archivoplas:        [],
      datoArchivoPla:     {},
      titulo:             "",
      btnEditar:          false,
      modalInstance:      null,
      sinResultados:      false,
      elementosPorPagina: 10,

      // ── Paginación tabla "sin -R" ───────────────────────────
      paginaActualSinR:   1,
      datosPaginadosSinR: [],

      // ── Paginación tabla "con -R" ───────────────────────────
      paginaActualConR:   1,
      datosPaginadosConR: [],

      // ── Ordenamiento (aplica a ambas tablas) ────────────────
      campoOrden:         'nombre',
      ascendente:         true,

      // ── Filtro (aplica a ambas tablas) ──────────────────────
      filtroNombre:       '',
    };
  },

  computed: {
    // ── Filtrados y ordenados (todos, antes de dividir) ───────
    archivoplasOrdenados() {
      const campo = this.campoOrden;

      let lista = this.archivoplas.filter(a => {
        return this.filtroNombre
          ? String(a.nombre ?? '').toLowerCase().includes(this.filtroNombre.toLowerCase())
          : true;
      });

      return lista.sort((a, b) => {
        const va = a[campo] ?? '';
        const vb = b[campo] ?? '';
        const cmp = String(va).localeCompare(String(vb), 'es');
        return this.ascendente ? cmp : -cmp;
      });
    },

    // ── División según si "ruta" contiene "-R" ─────────────────
    archivoplasSinR() {
      return this.archivoplasOrdenados.filter(a => !String(a.ruta ?? '').includes('-R'));
    },
    archivoplasConR() {
      return this.archivoplasOrdenados.filter(a => String(a.ruta ?? '').includes('-R'));
    },

    // ── Totales de páginas por tabla ────────────────────────────
    totalPaginasSinR() {
      return Math.max(1, Math.ceil(this.archivoplasSinR.length / this.elementosPorPagina));
    },
    totalPaginasConR() {
      return Math.max(1, Math.ceil(this.archivoplasConR.length / this.elementosPorPagina));
    },

    campos() {
      return [
        { label: 'Nombre',          value: this.datoArchivoPla.nombre },
        { label: 'Ruta',            value: this.datoArchivoPla.ruta },
        { label: 'Tipo',            value: this.datoArchivoPla.tipo },
        { label: 'Tamaño',          value: this.datoArchivoPla.tamano },
        { label: 'Hash',            value: this.datoArchivoPla.hash },
        { label: 'F. Creación',     value: this.getFormattedDate(this.datoArchivoPla.fechaCrea) },
        { label: 'F. Modificación', value: this.getFormattedDate(this.datoArchivoPla.fechaMod) },
      ];
    },
  },

  watch: {
    p_idPlanilla: {
      immediate: true,
      handler(val) {
        if (val && !isNaN(val)) {
          this.paginaActualSinR = 1;
          this.paginaActualConR = 1;
          this.cargarArchivos();
        }
      },
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.modalElement) {
        this.modalInstance = new Modal(this.$refs.modalElement);
      }
    });
  },

  beforeUnmount() {
    if (this.modalInstance) this.modalInstance.dispose();
  },

  methods: {
    // ── Ordenamiento ──────────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.aplicarPaginacion(1);
    },

    iconOrden(campo) {
      if (this.campoOrden !== campo) return '⇅';
      return this.ascendente ? '↑' : '↓';
    },

    // ── Paginación (recalcula ambas tablas) ────────────────────
    aplicarPaginacion(noPagina) {
      this.irPaginaSinR(noPagina);
      this.irPaginaConR(noPagina);
    },

    irPaginaSinR(noPagina) {
      if (noPagina < 1 || noPagina > this.totalPaginasSinR) return;
      this.paginaActualSinR = noPagina;
      const ini = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginadosSinR = this.archivoplasSinR.slice(ini, ini + this.elementosPorPagina);
    },

    irPaginaConR(noPagina) {
      if (noPagina < 1 || noPagina > this.totalPaginasConR) return;
      this.paginaActualConR = noPagina;
      const ini = (noPagina - 1) * this.elementosPorPagina;
      this.datosPaginadosConR = this.archivoplasConR.slice(ini, ini + this.elementosPorPagina);
    },

    // ── Carga de datos ────────────────────────────────────────
    async cargarArchivos() {
      this.sinResultados = false;
      try {
        const { data } = await api.get(`/vwarchivoplas/idplanilla/${this.p_idPlanilla}`);
        this.archivoplas = Array.isArray(data) ? data.reverse() : [];
        this.aplicarPaginacion(1);
        this.sinResultados = this.archivoplas.length === 0;
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los archivos',
          confirmButtonColor: '#dc3545',
        });
      }
    },

    // ── Modal ─────────────────────────────────────────────────
    async abrirModalEditar(idArchivoPla) {
      if (!idArchivoPla) return;
      try {
        const { data } = await api.get(`/vwarchivoplas/${idArchivoPla}`);
        this.datoArchivoPla = data;
        this.titulo         = 'Datos del archivo';
        this.btnEditar      = true;
        this.modalInstance?.show();
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar el detalle del archivo',
          confirmButtonColor: '#dc3545',
        });
      }
    },

    cerrarModal() {
      this.modalInstance?.hide();
    },

    // ── Helpers ───────────────────────────────────────────────
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    transformarRutaEnURL(ruta) {
      return '/archivos' + ruta;
    },
	
async confirmarEliminar(archivo) {
  const confirm = await Swal.fire({
    title: '¿Eliminar archivo?',
    text: `Se eliminará "${archivo.nombre}" de forma permanente.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#dc3545',
  });
  if (!confirm.isConfirmed) return;

  try {
    await api.delete(`/archivospla/${archivo.idArchivoPla}`);
    Swal.fire({
      icon: 'success',
      title: 'Eliminado',
      text: 'El archivo se eliminó correctamente',
      confirmButtonColor: '#0d6efd',
      timer: 1500,
      showConfirmButton: false,
    });
    this.cargarArchivos(); // refresca ambas tablas
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: err.response?.data || 'No se pudo eliminar el archivo',
      confirmButtonColor: '#dc3545',
    });
  }
},	
  },
};
</script>

<style scoped>
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover {
  background-color: #3d5166;
}
.table-hover tbody tr {
  cursor: pointer;
}
.material-icons {
  vertical-align: middle;
}
.info-registro {
  background-color: #f8f9fa;
  border-left: 4px solid #0d6efd;
}
</style>